import { MaterialTopTabScreenProps } from "@react-navigation/material-top-tabs";
import {
  CompositeScreenProps,
  NavigatorScreenParams,
} from "@react-navigation/native";
import { NativeStackScreenProps } from "@react-navigation/native-stack";

export const productFormRoutes = {
  tabs: {
    navigator: "Tabs",
    description: "Descripción",
    prices: "Precios",
    inventory: "Inventario",
    variants: "Variantes",
  },
  priceForm: "PriceForm",
  variantForm: "VariantForm",
  variantCombinations: "VariantCombinations",
  combinationInventory: "CombinationInventory",
} as const;

export type StackParamList = {
  [productFormRoutes.tabs.navigator]: NavigatorScreenParams<TabParamList>;
  [productFormRoutes.variantForm]: { selectedVariant?: string } | undefined;
  [productFormRoutes.variantCombinations]: undefined;
  [productFormRoutes.combinationInventory]: undefined;
  [productFormRoutes.priceForm]: { selectedPriceIndex: number } | undefined;
};

export type TabParamList = {
  [productFormRoutes.tabs.description]: undefined;
  [productFormRoutes.tabs.prices]: undefined;
  [productFormRoutes.tabs.variants]: undefined;
  [productFormRoutes.tabs.inventory]: undefined;
};

export type StackScreen = keyof StackParamList;
export type TabScreen = keyof TabParamList;

export type StackScreenProps<T extends StackScreen = StackScreen> =
  NativeStackScreenProps<StackParamList, T>;

export type TabScreenProps<T extends TabScreen = TabScreen> =
  CompositeScreenProps<
    MaterialTopTabScreenProps<TabParamList, T>,
    StackScreenProps<StackScreen>
  >;
